<template>

    <div>
      <input type="password" class="form-control" ref="input" :value="myValue" @change="updateValue" @input="inputValue" @blur="updateValue" >
    </div>

</template>

<script>
export default {
    props:['value'],
    data(){
        return {myValue:'' }
    },
    created:function(){
        this.myValue = this.value.toString();
    },
    
    watch:{
        value:function(val){
            this.myValue = val
        }
    },
    
    methods:{
         updateValue:function(){
            let val = this.$refs.input.value;
            this.myValue = val
            this.$emit('change',val)
            this.$emit('input',val)
        },
         inputValue:function(e){
            let val = this.$refs.input.value;
            this.myValue = val
            this.$emit('input',val)
        },

    }
}
</script>

<style>

</style>
